export const ACCESS_TOKEN = "access_token";
export const REFRESH_TOKEN = "refresh_token";
export const SESSION_ID = "session_id";
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/gif", "video/mp4", "video/quicktime"];
export const MAX_FILES = 4;
export const MAX_TOTAL_SIZE_MB = 30;
export const MAX_TOTAL_SIZE_BYTES = MAX_TOTAL_SIZE_MB * 1024 * 1024;
export const SERVER_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
export const API_BASE_URL = `${SERVER_URL}/api/v1`;
